import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../store';
import { AuthState } from '../store/auth/types';

interface WithoutAuthProps {}

const withoutAuth = <P extends object>(Component: React.ComponentType<P>) => {
    const WithoutAuth: React.FC<P & WithoutAuthProps> = ({ ...props }) => {
        const { user } = useSelector<RootState, AuthState>((state) => state.auth);
        if (user) {
            return <Navigate to="/home" replace />;
        }
        return <Component {...(props as P)} />;
    };
    return WithoutAuth;
};

export default withoutAuth;
